/**
 * Runtime configuration fetched from /config.json at startup.
 *
 * /config.json is written to S3 by CDK at deploy time with the correct values
 * for the target environment. This avoids baking environment-specific values
 * (Cognito IDs, API endpoint) into the frontend build.
 *
 * Fallback: if /config.json is not present (local development), values are
 * read from Vite environment variables (.env.local) so the local dev workflow
 * is unchanged.
 */

interface RuntimeConfig {
  userPoolId: string;
  userPoolClientId: string;
  apiEndpoint: string;
  apiRegion: string;
}

let _config: RuntimeConfig | null = null;

export function setRuntimeConfig(config: RuntimeConfig): void {
  _config = config;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (_config) return _config;
  // Fallback for local development (real Cognito via .env.local)
  return {
    userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
    userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
    apiEndpoint: import.meta.env.VITE_API_ENDPOINT || '',
    apiRegion: import.meta.env.VITE_AWS_REGION || 'us-west-2',
  };
}
